module.exports = __webpack_public_path__ + "static/media/pond-landscape.b51090ac.png";